module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921082649_T.268aa30e.jpg";